import {filter} from 'rxjs/operators';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {FuseConfigService} from '../../services/config.service';

@Component({
    selector: 'filter-menu',
    templateUrl: './filter-menu.html',
    styleUrls: ['./filter-menu.scss'],
    standalone: false
})

export class FilterMenuComponent implements OnInit, OnChanges{

  @Input() filters;
  @Input() page;
  @Input() filterFromDB;
  @Output() chooseFilter = new EventEmitter();

  showCountry = true;
  showCanton = true;
  showOrganization = true;
  showTag = true;
  showParishOrganization = true;
  showActivity = true;
  showRole = true;
  showTargetGroup = false;
  showEventType = false;
  showCantonFB = true;
  showOrganizationFB = true;
  showMarketplaceCategories = true;

  countryIdRoute;
  cityIdRoute;
  orgIdRoute;

  eventRegistrationModel;
  mileStoneEventModel;
  migrateEventModel;
  publicEventsModel;
  myEventsModel;
  activatedModel;
  noActivatedModel;
  publicBlogsModel;
  recommendatorModel;
  learningPathsVisibilityModel;
  platformsModel;

  activeFilters = false;

  marketplaceType;
  marketplaceStatus;

  constructor(private route: ActivatedRoute, public fuseConfig: FuseConfigService) {
    this.fuseConfig.activeFilter.subscribe((res) => {
      this.activeFilters = res;
    });
  }

  ngOnInit() {
    this.route.queryParams.pipe(filter(params => params.country)).subscribe(params => {
      if (params && params.subCountry) {
        this.cityIdRoute = params.subCountry;
      }
      if (params && params.orgId) {
        this.orgIdRoute = params.orgId;
      }
      if (params && params.country) {
        this.countryIdRoute = params.country;
      }
    });
  }

  ngOnChanges(change) {
    if (this.page && this.filterFromDB && this.filters) {
      // console.log(this.filters);
      if (this.page === 'admin') {
        if (this.filterFromDB.hasOwnProperty('admin')) {
          this.checkRoles('admin');
          this.checkCountries('admin');
          this.checkCantons('admin');
          this.checkOrganizations('admin');

          this.checkActivated();
          this.checkRecommendator();
        }
      }
      if (this.page === 'event') {
        if (this.filterFromDB.hasOwnProperty('event')) {
          this.checkCountries('event');
          this.checkCantons('event');
          this.checkOrganizations('event');
          this.checkEventTypes('event');
          this.checkTargetGroups('event');

          this.checkEventRegistration();
          this.checkMileStoneEvent();
          this.checkMigrateEvent();
          this.checkPublicEvents();
          this.checkMyEvents();
        }
      }
      if (this.page === 'budget') {

      }
      if (this.page === 'organization') {
        if (this.filterFromDB.hasOwnProperty('organization')) {
          this.checkCountries('organization');
          this.checkCantons('organization');
        }
      }
      if (this.page === 'user') {
        if (this.filterFromDB.hasOwnProperty('user')) {
          this.checkRoles('user');
          this.checkCountries('user');
          this.checkCantons('user');
          this.checkOrganizations('user');
          this.checkTargetGroups('user');
          this.checkTags('user');
          this.checkParishOrganizations('user');
          this.checkActivities('user');
        }
      }
      if (this.page === 'calendar') {

      }
      if (this.page === 'canton') {
        if (this.filterFromDB.hasOwnProperty('canton')) {
          this.checkCountries('canton');
        }
      }
    }
    if (this.page === 'marketplace') {
      this.marketplaceType = '';
      this.marketplaceStatus = '';
    }
    if (this.page === 'user') {
        if (this.filters.roles && this.filters.roles.length < 3) {
          this.filters.roles.push({id: 999, name: 'parent_student'});
        }
    }
  }

  choose(e) {
    this.chooseFilter.emit({choose: e});
  }

  chooseCanton(e) {
    this.chooseFilter.emit({choose: {canton: e.options[0].value, selected: e.options[0].selected}});
  }

  chooseRole(e) {
    this.chooseFilter.emit({choose: {role: e.options[0].value, selected: e.options[0].selected}});
  }

  chooseTG(e) {
    this.chooseFilter.emit({choose: {targetGroups: e.options[0].value, selected: e.options[0].selected}});
  }

  chooseMarketplaceCategory(e) {
    this.chooseFilter.emit({choose: {marketplaceCategory: e.options[0].value, selected: e.options[0].selected}});
  }

  chooseOrg(e) {
    this.chooseFilter.emit({choose: {organization: e.options[0].value, selected: e.options[0].selected}});
  }

  chooseTags(e) {
    this.chooseFilter.emit({choose: {tag: e.options[0].value, selected: e.options[0].selected}});
  }

  chooseParishOrganizations(e) {
    this.chooseFilter.emit({choose: {parishOrganization: e.options[0].value, selected: e.options[0].selected}});
  }

  chooseActivities(e) {
    this.chooseFilter.emit({choose: {activity: e.options[0].value, selected: e.options[0].selected}});
  }

  checkCountries(page) {
    if (this.filters.hasOwnProperty('countries') && this.filterFromDB[page].hasOwnProperty('country')) {
      this.filters.countries.forEach(el => {
        if (+this.filterFromDB[page].country === +el.id) {
          if (!el.selected) {
            el.selected = true;
            // this.chooseFilter.emit({choose: {country: el.id}});
          }
        } else {
          if (el.selected) {
            el.selected = false;
          }
        }
      });
    }
  }

  checkCantons(page) {
    if (this.filters.hasOwnProperty('cantons') && this.filterFromDB[page].hasOwnProperty('cantons')) {
      this.filters.cantons.forEach(el => {
        if (this.filterFromDB[page].cantons.indexOf(+el.id) !== -1) {
          if (!el.selected) {
            el.selected = true;
            // this.chooseFilter.emit({choose: {canton: el.id, selected: el.selected}});
          }
        }
      });
    }
  }

  checkOrganizations(page) {
    if (this.filters.hasOwnProperty('organizations') && this.filterFromDB[page].hasOwnProperty('organizations')) {
      this.filters.organizations.forEach(el => {
        if (this.filterFromDB[page].organizations.indexOf(+el.id) !== -1) {
          if (!el.selected) {
            el.selected = true;
            // this.chooseFilter.emit({choose: {organization: el.id, selected: el.selected}});
          }
        }
      });
    }
  }

  checkEventTypes(page) {
    // console.log(this.filterFromDB[page]);
    if (this.filters.hasOwnProperty('eventTypes') && this.filterFromDB[page].hasOwnProperty('eventTypes')) {
      this.filters.eventTypes.forEach(el => {
        if (this.filterFromDB[page].eventTypes.indexOf(+el.id) !== -1) {
          if (!el.selected) {
            el.selected = true;
            // this.chooseFilter.emit({choose: {eventType: el.id, selected: el.selected}});
          }
        }
      });
    }
  }

  checkTargetGroups(page) {
    if (this.filters.hasOwnProperty('targetGroups') && this.filterFromDB[page].hasOwnProperty('targetGroups')) {
      this.filters.targetGroups.forEach(el => {
        // console.log(el);
        if (this.filterFromDB[page].targetGroups.indexOf(+el.id) !== -1) {
          // console.log('1');
          if (!el.selected) {
            el.selected = true;
            // this.chooseFilter.emit({choose: {targetGroups: el.id, selected: el.selected}});
          }
        }
      });
    }
  }

  checkTags(page) {
    if (this.filters.hasOwnProperty('tags') && this.filterFromDB[page].hasOwnProperty('tags')) {
      this.filters.tags.forEach(el => {
        if (this.filterFromDB[page].tags.indexOf(+el.id) !== -1) {
          if (!el.selected) {
            el.selected = true;
            // this.chooseFilter.emit({choose: {targetGroups: el.id, selected: el.selected}});
          }
        }
      });
    }
  }

  checkParishOrganizations (page) {
    if (this.filters.hasOwnProperty('parishOrganizations') && this.filterFromDB[page].hasOwnProperty('parishOrganization')) {
      this.filters.parishOrganizations.forEach(el => {
        if (this.filterFromDB[page].parishOrganization.indexOf(+el.id) !== -1) {
          if (!el.selected) {
            el.selected = true;
          }
        }
      });
    }
  }

  checkActivities (page) {
    if (this.filters.hasOwnProperty('activities') && this.filterFromDB[page].hasOwnProperty('activity')) {
      this.filters.activities.forEach(el => {
        if (this.filterFromDB[page].activity.indexOf(+el.id) !== -1) {
          if (!el.selected) {
            el.selected = true;
          }
        }
      });
    }
  }

  checkRoles(page) {
    if (this.filters.hasOwnProperty('roles') && this.filterFromDB[page].hasOwnProperty('roles')) {
      this.filters.roles.forEach(el => {
        if (this.filterFromDB[page].roles.indexOf(+el.id) !== -1) {
          if (!el.selected) {
            el.selected = true;
            // this.chooseFilter.emit({choose: {role: el.id, selected: el.selected}});
          }
        }
      });
    }
  }

  checkEventRegistration() {
    if (this.filters.hasOwnProperty('eventRegistration') && this.filterFromDB.event &&
      this.filterFromDB.event.hasOwnProperty('eventRegistration')) {
      if (this.filterFromDB.event.eventRegistration) {
        if (!this.eventRegistrationModel) {
          this.eventRegistrationModel = true;
          // this.chooseFilter.emit({choose: {eventRegistration: true, selected: true}});
        }
      }
    }
  }

  checkMileStoneEvent() {
    if (this.filters.hasOwnProperty('mileStoneEvent') && this.filterFromDB.event &&
      this.filterFromDB.event.hasOwnProperty('mileStoneEvent')) {
      if (this.filterFromDB.event.mileStoneEvent) {
        if (!this.mileStoneEventModel) {
          this.mileStoneEventModel = true;
          // this.chooseFilter.emit({choose: {mileStoneEvent: true, selected: true}});
        }
      }
    }
  }

  checkMigrateEvent() {
    if (this.filters.hasOwnProperty('migrate') && this.filterFromDB.event &&
      this.filterFromDB.event.hasOwnProperty('migrate')) {
      if (this.filterFromDB.event.migrate) {
        if (!this.migrateEventModel) {
          this.migrateEventModel = true;
          // this.chooseFilter.emit({choose: {mileStoneEvent: true, selected: true}});
        }
      }
    }
  }

  checkPublicEvents() {
    if (this.filters.hasOwnProperty('publicEvents') && this.filterFromDB.event &&
      this.filterFromDB.event.hasOwnProperty('publicEvents')) {
      if (this.filterFromDB.event.publicEvents) {
        if (!this.publicEventsModel) {
          this.publicEventsModel = this.filterFromDB.event.publicEvents;
          // this.chooseFilter.emit({choose: {publicEvents: this.publicEventsModel}});
        }
      }
    }
  }
  checkMyEvents() {
    if (this.filters.hasOwnProperty('myEvents') && this.filterFromDB.event &&
      this.filterFromDB.event.hasOwnProperty('myEvents')) {
      if (this.filterFromDB.event.myEvents) {
        if (!this.myEventsModel) {
          this.myEventsModel = this.filterFromDB.event.myEvents;
        }
      }
    }
  }

  checkActivated() {
    if (this.filters.hasOwnProperty('activated') && this.filterFromDB.admin &&
      this.filterFromDB.admin.hasOwnProperty('activated')) {
      if (this.filterFromDB.admin.activated) {
        if (!this.activatedModel) {
          this.activatedModel = this.filterFromDB.admin.activated;
          // this.chooseFilter.emit({choose: {activated: true}});
        }
      }
    }
  }

  checkRecommendator() {
    if (this.filters.hasOwnProperty('recommendator') && this.filterFromDB.admin &&
      this.filterFromDB.admin.hasOwnProperty('recommendator')) {
      if (this.filterFromDB.admin.recommendator) {
        if (!this.recommendatorModel) {
          this.recommendatorModel = this.filterFromDB.admin.recommendator;
        }
      }
    }
  }
  checkNoActivated() {
    if (this.filters.hasOwnProperty('noActivated') && this.filterFromDB.admin &&
      this.filterFromDB.admin.hasOwnProperty('noActivated')) {
      if (this.filterFromDB.admin.noActivated) {
        if (!this.activatedModel) {
          this.activatedModel = this.filterFromDB.admin.noActivated;
          // this.chooseFilter.emit({choose: {activated: true}});
        }
      }
    }
  }
}
